<template>
  <div>
    <div
      class="input-group date dateMonthField"
      v-datetime-picker="true"
      ref="picker"
    >
      <label
        ><input
          type="number"
          class="form-control ime-mode-disabled"
          :class="{
            'is-invalid': hasError
          }"
          size="3"
          maxlength="2"
          :value="month"
          data-input-month
          @input="updateMonth($event.target.value)"
          @blur="checkMonth"
          @wheel="scrollStop"
        />月</label
      >
      <label
        ><input
          type="number"
          class="form-control ime-mode-disabled"
          :class="{
            'is-invalid': hasError
          }"
          size="3"
          maxlength="2"
          :value="day"
          data-input-day
          @input="updateDay($event.target.value)"
          @blur="checkDate"
          @wheel="scrollStop"
        />日</label
      >
      <div class="hiddenField">
        <input
          type="text"
          class="form-control datetimepicker-input"
          data-input
          :value="datemonth"
          @input="updateDateMonth($event.target.value)"
        />
      </div>
      <div class="input-group-prepend" data-toggle="datetimepicker">
        <div class="input-group-text">
          <img src="../assets/img/common/calendar-check.png" alt="" />
        </div>
      </div>
    </div>

    <div class="invalid-feedback" v-if="hasError && errorMessage">
      {{ errorMessage }}
    </div>
  </div>
</template>

<script>
import {
  startOfMonth as dateFnsStartOfMonth,
  endOfMonth as dateFnsEndOfMonth,
  startOfDay as dateFnsStartOfDay,
  getYear as dateFnsGetYear,
  getMonth as dateFnsGetMonth,
  subDays as dateFnsSupDays,
  addYears as dateFnsAddYears,
  isWithinRange as dateFnsIsWithinRange
} from "date-fns";

export default {
  props: {
    month: { type: String },
    day: { type: String },
    datemonth: { type: String },
    hasError: { type: Boolean },
    errorMessage: { type: String },
    coop_no: { type: String },
    tehaisaki_kbn: { type: String }
  },
  data() {
    return {
      isForce: false,
      currentYear: dateFnsGetYear(new Date()),
      currentMonth: dateFnsGetMonth(new Date()) + 1,
      min: dateFnsStartOfDay(new Date()),
      max: dateFnsSupDays(
        dateFnsAddYears(dateFnsStartOfMonth(new Date()), 1),
        1
      )
    };
  },
  mounted() {
    if (this.datemonth && !this.month && !this.day) {
      this.updateDateMonth(this.datemonth);
    }
  },
  watch: {
    datemonth(newVal, oldVal) {
      if (newVal === oldVal) {
        return;
      }

      if (this.isForce) {
        return;
      }

      if (!this.$refs.picker || !this.$refs.picker._flatpickr) {
        return;
      }

      if (newVal === null || !(newVal + "").length) {
        this.$refs.picker._flatpickr.jumpToDate(new Date());
        this.$refs.picker._flatpickr.clear();
        this.buildMonthSwitch();
        return;
      }

      this.applyFromDateMonth();

      // カレンダーを更新する
      const year = this.$dateFns.format(this.datemonth, "YYYY") - 0;
      const month = this.$dateFns.format(this.datemonth, "M") - 0;
      const day = this.$dateFns.format(this.datemonth, "M") - 0;

      const targetDate = new Date(year, month - 1, day);
      this.$refs.picker._flatpickr.setDate(targetDate);
      this.$refs.picker._flatpickr.jumpToDate(targetDate);
      this.buildMonthSwitch();
    }
  },
  methods: {
    // 月フィールドが更新された時に実行
    updateMonth(month) {
      this.$emit("change-month", month);

      this.$nextTick(() => {
        this.applyDateMonth();
      });
    },
    // 日フィールドが更新された時に実行
    updateDay(day) {
      this.$emit("change-day", day);

      this.$nextTick(() => {
        this.applyDateMonth();
      });
    },
    // 月日入力フィールドが更新された時に実行
    // 月日入力フィールドが直接更新されるのは、カレンダーから選択された場合のみ
    updateDateMonth(datemonth) {
      this.$emit("change-datemonth", datemonth);

      this.$nextTick(() => {
        this.applyFromDateMonth();
      });
    },
    // 月日の入力フィールドから入力した場合
    applyDateMonth() {
      if (!this.$refs.picker || !this.$refs.picker._flatpickr) {
        return;
      }
      this.$refs.picker._flatpickr.close();

      let yearNum = this.currentYear;
      const monthNum = this.month - 0;
      const dayNum = this.day - 0;

      if (!monthNum && !dayNum) {
        this.$refs.picker._flatpickr.jumpToDate(new Date());
        this.$refs.picker._flatpickr.clear();
        this.buildMonthSwitch();
        return;
      }

      let targetDate = new Date(
        yearNum,
        (monthNum || this.currentMonth) - 1,
        dayNum || 1
      );
      if (
        !dateFnsIsWithinRange(targetDate, this.min, this.max) &&
        monthNum &&
        monthNum !== this.currentMonth
      ) {
        yearNum += 1;
        targetDate = new Date(
          yearNum,
          (monthNum || this.currentMonth) - 1,
          dayNum || 1
        );
      }

      if (!monthNum || !dayNum) {
        this.isForce = true;
        this.$refs.picker._flatpickr.jumpToDate(targetDate);
        this.$refs.picker._flatpickr.clear();
        this.buildMonthSwitch();
        return;
      }

      const dateString = `${yearNum}/${this.$d3.format(
        monthNum - 0,
        "02d"
      )}/${this.$d3.format(dayNum - 0, "02d")}`;

      this.$refs.picker._flatpickr.jumpToDate(targetDate);
      this.buildMonthSwitch();
      this.$emit("change-datemonth", dateString);
    },
    // カレンダーから選択した場合
    applyFromDateMonth() {
      if (this.isForce) {
        this.isForce = false;
        return;
      }

      if (!this.datemonth || !(this.datemonth + "").length) {
        this.$emit("change-month", "");
        this.$emit("change-day", "");
        return;
      }

      this.$emit("change-month", this.$dateFns.format(this.datemonth, "M"));
      this.$emit("change-day", this.$dateFns.format(this.datemonth, "D"));
    },
    // 月フィールド入力チェック
    checkMonth() {
      if (event.target.validity.badInput) {
        this.updateMonth("");
      }
    },
    // 日フィールド入力チェック
    checkDate() {
      if (event.target.validity.badInput) {
        this.updateDay("");
      }
    },
    // スクロールでカウントしないように防止
    scrollStop() {
      if (event.preventDefault) {
        event.preventDefault();
      }
    },

    /**
     * Flatpickerの不具合の対処
     * （jumpToDateで移動すると、月が更新されない）
     */
    buildMonthSwitch() {
      if (!this.$refs.picker || !this.$refs.picker._flatpickr) {
        return;
      }
      const flatpicker = this.$refs.picker._flatpickr;
      const currentYear = flatpicker.currentYear;
      const currentMonth = flatpicker.currentMonth;
      const dropDownContainer = flatpicker.monthsDropdownContainer;

      dropDownContainer.tabIndex = -1;
      dropDownContainer.innerHTML = "";

      for (var i = 0; i < 12; i++) {
        const compareFirstDate = new Date(currentYear, i, 1);
        const compareLastDate = dateFnsEndOfMonth(compareFirstDate);
        if (
          !dateFnsIsWithinRange(compareFirstDate, this.min, this.max) &&
          !dateFnsIsWithinRange(compareLastDate, this.min, this.max)
        ) {
          continue;
        }

        const month = document.createElement("option");
        month.setAttribute("class", "flatpickr-monthDropdown-month");
        month.value = i;
        month.textContent = `${i + 1}月`;
        month.tabIndex = 0;
        if (currentMonth === i) {
          month.selected = true;
        }
        dropDownContainer.appendChild(month);
      }
    }
  }
};
</script>
